import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../../variables';
import { H3Atom, PAtom } from '../../../atoms/text-atoms/text-atoms';
import Tag from './tag';

const OrganisationNameCell = ({ name, sector, tag, className }) => {
  return (
    <td className={className}>
      {name && <H3Atom>{name}</H3Atom>}
      {sector && <PAtom>{sector}</PAtom>}
      {tag && tag.text && tag.colour && (
        <Tag colour={tag.colour}>{tag.text}</Tag>
      )}
    </td>
  );
};

// === OrganisationNameCell CSS ===
const StyledOrganisationNameCell = styled(OrganisationNameCell)`
  ${H3Atom} {
    margin: 0 0 ${vars.spacingXs} 0;
    ${vars.fontSize4}
    font-weight: ${vars.fontWeightMedium};
  }
  ${PAtom} {
    ${vars.fontSize1}
    font-weight: ${vars.fontWeightRegular};
  }
`;

export default StyledOrganisationNameCell;
